import React from 'react';
import { FormattedNumber } from 'react-intl';
import PageLink from 'components/PageLink/PageLink';
import { useAppDispatch } from 'app/hooks';
import http, { fetcher } from 'app/http';
import { setDataLoading } from 'features/core/reducer';
import classNames from 'classnames';

interface Props {
  PageData?: any;
  Model?: any;
}

const PayerReviewWithOffer = ({ PageData, Model }: Props) => {

  const dispatch = useAppDispatch();

  const handlePayerReviewUrl = async (url: any) => {
    try {
      dispatch(setDataLoading(true));
      const response = await http.get(url)
      if (response.data) {
        setDataLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div data-type="Promotion" data-creative-slot="Portal-Home-Top" data-promotion-name="Payer review" >
      <div className="ReviewdPaymentPlan">
        <div className="ReviewdPaymentPlan__header">
          {PageData?.TimeToReviewPlanHeader}
        </div>
        <div className="ReviewdPaymentPlan__content">
          <div className="ReviewdPaymentPlan__title">
            <h3 className="ReviewdPaymentPlan__heading">
              {PageData?.PayerReviewGetLabel}{' '}
              <span>{PageData?.PayerReviewDebtFreeLabel} </span>
              {PageData?.PayerReviewFasterWithText}
            </h3>
            <h4 className="ReviewdPaymentPlan__discount">
              {PageData?.PayerReviewDiscountSettlementHeader}
            </h4>
          </div>
          <div className="ReviewdPaymentPlan__section">
            <div className="ReviewdPaymentPlan__offer">
              <div className="ReviewdPaymentPlan__label">
                {PageData?.PayerReviewYourDebtLabel}
                <div className="ReviewdPaymentPlan__value">
                  {Model?.FormattedCurrencyDebtBalance}
                </div>
              </div>
              <i className="ReviewdPaymentPlan__icon"></i>
              <div className="ReviewdPaymentPlan__label u-borderLsolid">
                {PageData?.PayerReviewYouPayLabel}
                <div className="ReviewdPaymentPlan__value u-colorTextBlue">
                  {Model?.FormattedCurrencyDiscountedDebtBalance}
                </div>
              </div>
            </div>

            <button className={classNames("ReviewdPaymentPlan__link",
                                           "Button btnreviewplan",
                                           Model?.HidePayerReviewProposedPlanTerm && 
                                           "u-marginBxxsm")}
              onClick={() => { handlePayerReviewUrl(Model?.ChangePayerReviewWithOfferUrl) }}>
              {PageData?.PayerReviewOfferHeaderText}</button>
            {!Model?.HidePayerReviewProposedPlanTerm && 
            (<div className="ReviewdPaymentPlan__notice">
              {PageData?.PayerReviewOfferInstalmentNotice}
              <strong> {Model?.Offer?.MaxNumberOfInstalments} </strong>
              {PageData?.PayerReviewPaymentLabel}
            </div>
            )}
          </div>
          <div className="ReviewdPaymentPlan__reviewplanbtnwrapper">

          {!Model?.HidePayerReviewUpdatePayment && (
              <>
                <p className="Text--medium u-marginTxsm u-paddingBxsm">
                  {PageData?.PayerReviewChooseAlternativeAmountLabel}
                </p>

                <div className="u-paddingTxxsm u-marginBxxsm">

                  <button className="Button Button--ghost blue-border btnreviewplan"
                    onClick={() => { handlePayerReviewUrl(Model?.UpdateAmountPayerReviewWithOfferUrl) }}>
                    {PageData?.UpdatePaymentAmountButtonLabel}</button>
                  </div>
              </>
            )
            }            
            <div className="u-center u-paddingTxxsm u-marginBxxsm">
              <strong>{PageData?.PayerReviewOrLabel}</strong>
            </div>
            <div className="u-paddingTxxsm">
              <button className="Button Button--ghost gray-border btnreviewplan"
                onClick={() => { handlePayerReviewUrl(Model?.PayerReviewDeclinedUrl) }}>
                {PageData?.KeepPlanTheSameLabel}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayerReviewWithOffer;
